import React from 'react'
import styled from 'styled-components';
import { sortableElement } from 'react-sortable-hoc'

const SortableItemContainer = styled.div`
  background-color: white;
`

const SortableItem = sortableElement(({children}) => (
  <SortableItemContainer>
    {children}
  </SortableItemContainer>
))

export default SortableItem
